import axios from 'axios';
import { getDiscadorApiUrl } from '../config/runtime-api';
import { getToken } from './util.service';

const apiClient = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    config.baseURL = getDiscadorApiUrl();

    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('Erro na resposta da API:', error.response.data);
      console.error('Status:', error.response.status);
    } else if (error.request) {
      console.error('Sem resposta da API:', error.request);
    } else {
      console.error('Erro na configuração:', error.message);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
